import { render, staticRenderFns } from "./SyntheticMediaBar.vue?vue&type=template&id=176ee53c&scoped=true"
import script from "./SyntheticMediaBar.vue?vue&type=script&lang=js"
export * from "./SyntheticMediaBar.vue?vue&type=script&lang=js"
import style0 from "./SyntheticMediaBar.vue?vue&type=style&index=0&id=176ee53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176ee53c",
  null
  
)

export default component.exports